exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ssg-form .change-email-action-bar {\n  background-color: inherit;\n  max-width: 416px;\n  text-align: right; }\n  .ssg-form .change-email-action-bar .ssg-forms-btn {\n    margin-left: 10px; }\n\n.ssg-form .full-width {\n  width: 100%; }\n\n.participants-type-icon {\n  width: 40px;\n  height: 40px;\n  color: #1F8475; }\n\n@media (max-width: 768px) {\n  .ssg-form .change-email-action-bar {\n    max-width: unset; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/acct/email/change-email.scss
// module id = 1334
// module chunks = 0